module.exports = __webpack_public_path__ + "static/media/simple.b775bd8d.png";